import { WebVTTParser } from 'webvtt-parser'
import subtitlesParser from 'subtitles-parser'

const compatibleTypes = ['text/vtt', 'application/x-subrip'] // vtt, srt

export const parseTranscript = (text, type) => {
  if (!text || !compatibleTypes.includes(type)) {
    return []
  }

  switch (type) {
    case 'text/vtt':
      return parseVtt(text)
    case 'application/x-subrip':
      return parseSrt(text)
    default:
      return []
  }
}

const parseVtt = (text) => {
  const parser = new WebVTTParser()
  const tree = parser.parse(text)
  return tree.cues.map((cue, index) => ({
    id: index,
    text: cue.text,
    startTime: Math.floor(cue.startTime),
    endTime: Math.floor(cue.endTime)
  }))
}

const parseSrt = (text) => {
  const cues = subtitlesParser.fromSrt(text, true)

  return cues.map((cue, index) => ({
    id: index,
    text: cue.text,
    startTime: Math.floor(cue.startTime / 1000),
    endTime: Math.floor(cue.endTime / 1000)
  }))
}
